import Vue from 'vue';
import logger from "./logger.js";

Vue.config.errorHandler = async (err, vm, info) => {
    if(process.env.NODE_ENV !== 'production' ){
        console.error(err, vm, info);
    }
    let url = window.location.href;
    let message = err.stack? err.stack:"no-stack error";
    let trace = info ? info.toString() : 'N/A';
    await logger.error(`[Vue.Error] from url ${url} error message is ${err.toString()} ${message}`, trace);
};

Vue.config.warnHandler = async (err, vm, info) => {
    if(process.env.NODE_ENV !== 'production' ){
        console.error(err, vm, info);
    }
    let url = window.location.href;
    let message = err.stack? err.stack:"no-stack error";
    let trace = info ? info.toString() : 'N/A';
    await logger.warning(`[Vue.Warn] from url ${url} error message is ${err.toString()} ${message}`, trace);
};

window.onerror = async (message, source, lineno, colno, error) => {
    let error_context = JSON.stringify(error) ? JSON.stringify(error):error.toString();
    let trace = source ? source.toString() : 'N/A';
    let url = window.location.href;
    if(process.env.NODE_ENV !== 'production' ){
        console.error(message, source, lineno, colno, error);
    }
    if(trace.includes('chrome-extension')){
        await logger.warning(`[Window.Error] from url ${url} error message is ${message}, source: ${trace}, error: ${error_context}`, trace);
    } else {
        await logger.error(`[Window.Error] from url ${url} error message is ${message}, source: ${trace}, error: ${error_context}`, trace);
    }
};
